module.exports = __webpack_public_path__ + "img/Brill.c03a85ec.jpg";